import { UTILITY_EVENT_TYPES } from "score-common";

// Utility event display metadata (card #139). UTILITY_EVENT_TYPES — the
// canonical BLOOD/LAMENESS key enum the server validates POST bodies
// against — lives in score-common; label/description/severity here are pure
// FE presentation, not part of the wire schema.
export const UTILITY_EVENT_TYPE_LIST = [
  {
    key: UTILITY_EVENT_TYPES.BLOOD,
    label: "BLOOD",
    description: "Visible blood — eliminates the ride per FEI / USDF rules.",
    severity: "error",
  },
  {
    key: UTILITY_EVENT_TYPES.LAMENESS,
    label: "LAMENESS",
    description: "Lameness called by the judge — may eliminate the ride.",
    severity: "warning",
  },
  // #1991 — not a welfare flag: a scribe flagging that the judge panel wants
  // a meeting. Only meaningful where a panel exists (more than one judge
  // position on the class) — `panelOnly` gates it out of UtilityTrigger's
  // menu for a single-judge class (see ScoringForm.jsx's isPanelClass,
  // expectedJudgeCountForClass from score-common — never a locally-computed
  // judge count).
  {
    key: UTILITY_EVENT_TYPES.MEETING_REQUESTED,
    label: "Meeting Requested",
    description: "A meeting with the judge panel has been requested.",
    severity: "info",
    panelOnly: true,
  },
];

export const UTILITY_EVENT_TYPE_BY_KEY = Object.fromEntries(
  UTILITY_EVENT_TYPE_LIST.map((t) => [t.key, t]),
);
